export default __webpack_public_path__ + "static/media/image-ph-health-home-m.6a514547.webp";